import {RootStore} from '../index';
import {action, makeAutoObservable} from "mobx";
import axios from "axios";
import {getNewsApiBaseUrl} from "../../helper/newsApi";



export class NewsStore {


    rowsNews = [];
    rowsDetail = []


    private rootStore: RootStore | undefined;

    constructor(rootStore?: RootStore) {
        makeAutoObservable(this);
        this.rootStore = rootStore;

    }

    init(val: boolean, code: string) {
        const url = `${getNewsApiBaseUrl()}/content/news`;
        if (val){

            axios.get(url)
                .then(res => {
                    this.rowsNews = res.data.data
                    this.filterNewsForDetailPage(code)
                })
        }else {
            axios.get(url)
                .then(res => {
                    this.rowsNews = res.data.data
                })
        }


    }

    @action
    filterNewsForDetailPage = (code: any)=> {
        this.rowsDetail = []
        if (this.rowsNews.length){
            for (let i =0 ; i < this.rowsNews.length; i++){
                // @ts-ignore
                if (this.rowsNews[i].name === code){
                    return this.rowsDetail = this.rowsNews[i]
                }
            }
        }

    }
}
